import * as React from 'react';
import type { SVGProps } from 'react';
const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M232.49 80.49L104.49 208.49C103.375 209.609 102.05 210.496 100.592 211.102C99.1333 211.708 97.5694 212.019 95.9901 212.019C94.4107 212.019 92.8468 211.708 91.3882 211.102C89.9296 210.496 88.6049 209.609 87.4901 208.49L31.4901 152.49C30.3738 151.374 29.4884 150.049 28.8843 148.59C28.2802 147.132 27.9692 145.569 27.9692 143.99C27.9692 142.411 28.2802 140.848 28.8843 139.39C29.4884 137.931 30.3738 136.606 31.4901 135.49C32.6063 134.374 33.9315 133.488 35.3899 132.884C36.8483 132.28 38.4115 131.969 39.9901 131.969C41.5687 131.969 43.1318 132.28 44.5902 132.884C46.0487 133.488 47.3738 134.374 48.4901 135.49L96.0001 183L215.51 63.51C217.764 61.2557 220.822 59.9892 224.01 59.9892C227.198 59.9892 230.256 61.2557 232.51 63.51C234.764 65.7643 236.031 68.8219 236.031 72.01C236.031 75.1981 234.764 78.2557 232.51 80.51L232.49 80.49Z"
      fill="currentColor"
    />
  </svg>
);
export default Check;
